import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export { BACKEND_URL };
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const uploadImage = async (file, authHeaders = {}) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads", fd, {
    headers: { ...authHeaders, "Content-Type": "multipart/form-data" },
  });
  // store absolute URL so <img src=...> works directly on the public site
  return `${BACKEND_URL}${data.url}`;
};

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Errore sconosciuto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  return String(detail);
};
